import React, { useEffect ,useState} from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { createVideos, getAVideo, resetState, updateAVideo } from "../features/VideoSlice";
import { toast } from "react-toastify";
import CustomInput from "../components/CustomInput";
let schema = yup.object().shape({
  title: yup.string().required("Title is Required"),
  videos: yup.string().required("Youtube Video Id is Required"),
});

const AddVideos = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const getNewsId = location.pathname.split("/")[3];
  const NewsState = useSelector((state) => state.Video);
  const { isSuccess, isError, isLoading, createdVideo, Videotitle,VideoVideos, updatedVideo } = NewsState;
  

  useEffect(() => {
    if (getNewsId !== undefined) {
      dispatch(getAVideo(getNewsId));
    } else {
      dispatch(resetState());
    }
  }, [getNewsId]);

  useEffect(() => {
    dispatch(resetState());
   
  }, []);

  useEffect(() => {
    if (isSuccess && createdVideo) {
      toast.success("Video Added Successfully!");
      navigate("/ppp/Videos-List");
    }
    if (isSuccess && updatedVideo) {
      toast.success("Video Updated Successfully!");
      navigate("/ppp/Videos-List");
    }
    if (isError) {
      toast.error("Something Went Wrong!");
    }
  }, [isSuccess, isError, isLoading]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      
      title: Videotitle || "",
      videos:VideoVideos|| "",
      
    },
    validationSchema: schema,
    onSubmit: (values) => {
      
      
      if (getNewsId !== undefined) {
        const data = { id: getNewsId, NewsData: values };
        dispatch(updateAVideo(data));
        dispatch(resetState());
      } else {
        dispatch(createVideos(values));
        formik.resetForm();
        setTimeout(() => {
          dispatch(resetState());
        }, 300);
      }
    },
  });



  return (
    <div>
      <h3 className="mb-4 title">{getNewsId !== undefined ? "Edit" : "Add"} Video</h3>

      <div className="">
        <form action="" onSubmit={formik.handleSubmit}>
          <div className="mt-4">
            <CustomInput
              type="text"
              label="Enter Video Title"
              name="title"
              onChng={formik.handleChange("title")}
              onBlr={formik.handleBlur("title")}
              val={formik.values.title}
            />
            <div className="error">{formik.touched.title && formik.errors.title}</div>
          </div>

          <div className="mt-4">
            <CustomInput
              type="text"
              label="Enter youtube video id "
              name="videos"
              onChng={formik.handleChange("videos")}
              onBlr={formik.handleBlur("videos")}
              val={formik.values.videos}
            />
            <div className="error">{formik.touched.videos && formik.errors.videos}</div>
          </div>
          


          <button className="btn btn-success border-0 rounded-3 my-5" type="submit">
            {getNewsId !== undefined ? "Edit" : "Add"} Video
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddVideos;